import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  tasks: [],
  milestones: [],
  secondaryGoals: [],
}

export default {
  state,
  actions,
  getters,
  mutations
}
